import './Spinner.css'

export type SpinnerSize = 'small' | 'medium' | 'large'

export interface SpinnerProps {
  /** Spinner size */
  size?: SpinnerSize
  /** Accessible label for screen readers */
  label?: string
  /** Show label text visually */
  showLabel?: boolean
}

/**
 * Loading spinner component
 * Accessible with aria-label
 */
export default function Spinner({
  size = 'medium',
  label = 'Loading',
  showLabel = false,
}: SpinnerProps) {
  return (
    <div
      className={`ps-spinner ps-spinner--${size}`}
      role="status"
      aria-label={label}
    >
      <svg
        className="ps-spinner__svg"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="31.416"
          strokeDashoffset="10"
        />
      </svg>
      {showLabel && <span className="ps-spinner__label">{label}</span>}
      <span className="sr-only">{label}</span>
    </div>
  )
}
